import { apiPath } from "../api-path"
import apiIms from "./service-ims"

export async function getSites() {
  return apiIms
    .get(apiPath.site)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}
